/**
 * Styles pour le footer "Powered by"
 * Design moderne inspiré de ChatModal.vue
 */
export const FOOTER_STYLES = `
  /* Powered by footer */
  .ringado-powered-by {
    padding: 8px 16px;
    border-top: 1px solid #f3f4f6;
    background: rgba(249, 250, 251, 0.3);
    backdrop-filter: blur(4px);
    border-radius: 0 0 16px 16px;
    position: relative;
    flex-shrink: 0;
  }

  .ringado-powered-by::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(to right, transparent, #f3f4f6 20%, #f3f4f6 80%, transparent);
  }

  .ringado-powered-by a {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: #6b7280;
    text-decoration: none;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.2s ease;
    padding: 4px 8px;
    border-radius: 6px;
    cursor: pointer;
  }

  .ringado-powered-by a:hover {
    color: #374151;
    background: rgba(255, 255, 255, 0.8);
  }

  .ringado-powered-by .brand {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 500;
  }

  .ringado-powered-by .hand-wave {
    font-size: 12px;
    transition: transform 0.3s ease;
  }

  .ringado-powered-by a:hover .hand-wave {
    animation: ringado-wave-on-hover 0.6s ease-in-out;
  }

  /* Animation pour le wave */
  @keyframes ringado-wave-on-hover {
    0%, 100% { transform: rotate(0deg); }
    25% { transform: rotate(20deg); }
    75% { transform: rotate(-10deg); }
  }

  /* Responsive adjustments */
  @media (max-width: 480px) {
    .ringado-powered-by {
      padding: 6px 12px;
    }

    .ringado-powered-by a {
      font-size: 11px;
    }
  }
`;
